import { FC } from 'react'
import { useRecordContext, useTranslate } from 'react-admin'
import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'
import { JsonView } from '../../components'
import { border } from '../../layout/theme/border'
import { themeColor } from '../../layout/theme/color'
import { AuditLogOut } from '../../types/apiRequests'

const PREFIX = 'xxllncAuditLogExpand'

const classes = {
  root: `${PREFIX}-root`,
  row: `${PREFIX}-row`,
  label: `${PREFIX}-label`,
  value: `${PREFIX}-value`,
}

const AuditLogExpand: FC = () => {
  const record = useRecordContext<AuditLogOut>()
  const translate = useTranslate()

  if (!record) return null

  const rows: { label: string; value: string | null | undefined }[] = [
    { label: translate('auditLog.action'), value: record.action },
    { label: translate('auditLog.actor'), value: record.actor_email },
    { label: translate('auditLog.actorUserId'), value: record.actor_user_id },
    { label: translate('auditLog.targetType'), value: record.target_type },
    { label: translate('auditLog.targetId'), value: record.target_id },
  ]

  return (
    <StyledBox className={classes.root}>
      {rows.map((row) => (
        <Box key={row.label} className={classes.row}>
          <span className={classes.label}>{row.label}</span>
          <span className={classes.value}>{row.value || '—'}</span>
        </Box>
      ))}
      <Box className={classes.row}>
        <span className={classes.label}>{translate('auditLog.context')}</span>
        <JsonView value={record.context} />
      </Box>
    </StyledBox>
  )
}

const StyledBox = styled(Box)(() => ({
  [`&.${classes.root}`]: {
    padding: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  [`& .${classes.row}`]: {
    display: 'grid',
    gridTemplateColumns: '180px 1fr',
    gap: 12,
    alignItems: 'start',
    paddingBottom: 8,
    borderBottom: `${border.thin} solid ${border.light}`,
  },
  [`& .${classes.label}`]: {
    color: themeColor.sidebarText,
    fontSize: 13,
    fontWeight: 600,
  },
  [`& .${classes.value}`]: {
    fontSize: 13,
    wordBreak: 'break-word',
  },
}))

export default AuditLogExpand
